export var SubscribeMessageEnum;
(function (SubscribeMessageEnum) {
    SubscribeMessageEnum["JOIN_MERCHANT_ROOM"] = "joinMerchantRoom";
    SubscribeMessageEnum["JOIN_WEB_STORE_USER_ROOM"] = "joinWebStoreUserRoom";
})(SubscribeMessageEnum || (SubscribeMessageEnum = {}));
//# sourceMappingURL=SubscribeMessageEnum.js.map